import { render, staticRenderFns } from "./PatientReports.vue?vue&type=template&id=e1d991ca&"
import script from "./PatientReports.vue?vue&type=script&lang=js&"
export * from "./PatientReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports